module.exports = __webpack_public_path__ + "static/media/bank-solution-small.2ba7d4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank-solution-small.png
// module id = 495
// module chunks = 0